import { Box, CircularProgress, Stack, Typography } from "@mui/material";

import { formatFileSize } from "@/common/helper/fileDownloadHelper";
import { useTranslation } from "@/translations";

interface Props {
  file: File;
}

export function DocumentWidgetUploading({ file }: Props) {
  const { t } = useTranslation();

  return (
    <Stack
      direction="row"
      aria-label={t("dropzone.fileList.uploading", { fileName: file.name })}
      sx={{ p: 0, minHeight: 0, alignItems: "center", gap: 1 }}
    >
      <Box sx={{ p: "9px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
        <CircularProgress size={28} />
      </Box>
      <Stack sx={{ overflow: "hidden", flex: 1 }}>
        <Typography variant="body2" noWrap>
          {file.name} ({formatFileSize(file.size)})
        </Typography>
      </Stack>
    </Stack>
  );
}
